import React from 'react';
import { pick } from 'lodash';

import AIAtlas from './AIAtlas';
import AnnotationsAtlas from './AnnotationsAtlas';
import AtlasIframe from './AtlasIframe';
import CarouselThree from './CarouselThree';
import CarouselFour from './CarouselFour';
import CarouselFive from './CarouselFive';
import FocusedTrainAtlas from './FocusedTrainAtlas';
import GraphicIframe from './GraphicIframe';
import GridDiceHorizontal from './GridDiceHorizontal';
import GridDiceVertical from './GridDiceVertical';
import GridFourQuarters from './GridFourQuarters';
import GridFourQuartersHorizontal from './GridFourQuartersHorizontal';
import GridFourQuartersVertical from './GridFourQuartersVertical';
import GridOne from './GridOne';
import GridOneHalfTwoQuarters from './GridOneHalfTwoQuarters';
import GridOneHalfTwoQuartersHorizontal from './GridOneHalfTwoQuartersHorizontal';
import GridSixSixthsVertical from './GridSixSixthsVertical';
import GridSixSixthsHorizontal from './GridSixSixthsHorizontal';
import GridThreeSixthsTwoQuartersHorizontal from './GridThreeSixthsTwoQuartersHorizontal';
import GridThreeSixthsTwoQuartersVertical from './GridThreeSixthsTwoQuartersVertical';
import GridThreeThirds from './GridThreeThirds';
import GridThreeThirdsVertical from './GridThreeThirdsVertical';
import GridTwoHalves from './GridTwoHalves';
import GridTwoHalvesHorizontal from './GridTwoHalvesHorizontal';
import GridTwoQuartersOneHalf from './GridTwoQuartersOneHalf';
import GridTwoQuartersOneHalfHorizontal from './GridTwoQuartersOneHalfHorizontal';
import GridTwoQuartersThreeSixthsHorizontal from './GridTwoQuartersThreeSixthsHorizontal';
import GridTwoQuartersThreeSixthsVertical from './GridTwoQuartersThreeSixthsVertical';
import ImageElement from './ImageElement';
import MapIframe from './MapIframe';
import Ogr2ogrConfiguration from './Ogr2ogrConfiguration';
import SectionsFive from './SectionsFive';
import SectionsFour from './SectionsFour';
import SectionsSix from './SectionsSix';
import SectionsThree from './SectionsThree';
import SectionsTwo from './SectionsTwo';
import TableIframe from './TableIframe';
import Text from './Text';
import TextNavbar from './TextNavbar';
import VideoPlayer from './VideoPlayer';
import CreateDataset from './CreateDataset';

export const ATLAS_PROP_TYPES = {
  COLOR: 'color',
  SELECT: 'select',
  STRING: 'string',
  TEXTAREA: 'textarea',
  NODE: 'node'
};

export const ATLAS_ELEMENTS = {
  ATLASIFRAME: 'AtlasIframe',
  GRAPHICIFRAME: 'GraphicIframe',
  IMAGEELEMENT: 'ImageElement',
  MAPIFRAME: 'MapIframe',
  OGR2OGRCONFIGURATION: 'Ogr2ogrConfiguration',
  TABLEIFRAME: 'TableIframe',
  TEXT: 'Text',
  TEXTNAVBAR: 'TextNavbar',
  VIDEOPLAYER: 'VideoPlayer',
  AIATLAS: 'AIAtlas',
  CREATEDATASET: 'CreateDataset',
  ANNOTATIONSATLAS: 'AnnotationsAtlas',
  CAROUSELTHREE: 'CarouselThree',
  CAROUSELFOUR: 'CarouselFour',
  CAROUSELFIVE: 'CarouselFive',
  GRIDDICEHORIZONTAL: 'GridDiceHorizontal',
  GRIDDICEVERTICAL: 'GridDiceVertical',
  GRIDFOURQUARTERS: 'GridFourQuarters',
  GRIDFOURQUARTERSHORIZONTAL: 'GridFourQuartersHorizontal',
  GRIDFOURQUARTERSVERTICAL: 'GridFourQuartersVertical',
  GRIDONE: 'GridOne',
  GRIDONEHALFTWOQUARTERS: 'GridOneHalfTwoQuarters',
  GRIDONEHALFTWOQUARTERSHORIZONTAL: 'GridOneHalfTwoQuartersHorizontal',
  GRIDSIXSIXTHSVERTICAL: 'GridSixSixthsVertical',
  GRIDSIXSIXTHSHORIZONTAL: 'GridSixSixthsHorizontal',
  GRIDTHREESIXTHSTWOQUARTERSHORIZONTAL: 'GridThreeSixthsTwoQuartersHorizontal',
  GRIDTHREESIXTHSTWOQUARTERSVERTICAL: 'GridThreeSixthsTwoQuartersVertical',
  GRIDTHREETHIRDS: 'GridThreeThirds',
  GRIDTHREETHIRDSVERTICAL: 'GridThreeThirdsVertical',
  GRIDTWOHALVES: 'GridTwoHalves',
  GRIDTWOHALVESHORIZONTAL: 'GridTwoHalvesHorizontal',
  GRIDTWOQUARTERSONEHALF: 'GridTwoQuartersOneHalf',
  GRIDTWOQUARTERSONEHALFHORIZONTAL: 'GridTwoQuartersOneHalfHorizontal',
  GRIDTWOQUARTERSTHREESIXTHSHORIZONTAL: 'GridTwoQuartersThreeSixthsHorizontal',
  GRIDTWOQUARTERSTHREESIXTHSVERTICAL: 'GridTwoQuartersThreeSixthsVertical',
  FOCUSEDTRAINATLAS: 'FocusedTrainAtlas',
  SECTIONSFIVE: 'SectionsFive',
  SECTIONSFOUR: 'SectionsFour',
  SECTIONSSIX: 'SectionsSix',
  SECTIONSTHREE: 'SectionsThree',
  SECTIONSTWO: 'SectionsTwo',
  properties: {
    ATLASIFRAME: {
      name: 'ATLASIFRAME',
      value: 'AtlasIframe',
      humanValue: 'Atlas',
      component: <AtlasIframe />,
      props: [
        { name: 'atlasTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Atlas Title' },
        {
          name: 'atlasTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Atlas Title Color'
        },
        {
          name: 'atlasTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Atlas Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'atlasTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Atlas Title Text Size (i.e. 15px, 30%...)'
        },
        {
          name: 'atlasSource',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Atlas Source URL'
        },
        {
          name: 'atlasExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Atlas External URL'
        }
      ]
    },
    GRAPHICIFRAME: {
      name: 'GRAPHICIFRAME',
      value: 'GraphicIframe',
      humanValue: 'Graphic',
      component: <GraphicIframe />,
      props: [
        { name: 'graphicTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Graphic Title' },
        {
          name: 'graphicTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Graphic Title Color'
        },
        {
          name: 'graphicTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Graphic Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'graphicTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Graphic Title Text Size (i.e. 15px, 30%...)'
        },
        {
          name: 'graphicSource',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Graphic Source URL'
        },
        {
          name: 'graphicExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Graphic External URL'
        }
      ]
    },
    IMAGEELEMENT: {
      name: 'IMAGEELEMENT',
      value: 'ImageElement',
      humanValue: 'Image',
      component: <ImageElement />,
      props: [
        { name: 'imageTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Image Title' },
        {
          name: 'imageTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Image Title Color'
        },
        {
          name: 'imageTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Image Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'imageTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Image Title Text Size (i.e. 15px, 30%...)'
        },
        { name: 'imageSource', type: 'string', humanValue: 'Image Source URL' },
        {
          name: 'imageExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Image External URL'
        }
      ]
    },
    MAPIFRAME: {
      name: 'MAPIFRAME',
      value: 'MapIframe',
      humanValue: 'Map',
      component: <MapIframe />,
      props: [
        { name: 'mapTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Map Title' },
        {
          name: 'mapTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Map Title Color'
        },
        {
          name: 'mapTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Map Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'mapTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Map Title Text Size (i.e. 15px, 30%...)'
        },
        { name: 'mapSource', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Map Source URL' },
        {
          name: 'mapExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Map External URL'
        }
      ]
    },
    OGR2OGRCONFIGURATION: {
      name: 'OGR2OGRCONFIGURATION',
      value: 'Ogr2ogrConfiguration',
      humanValue: 'Ogr2ogr',
      component: <Ogr2ogrConfiguration />,
      props: []
    },
    TABLEIFRAME: {
      name: 'TABLEIFRAME',
      value: 'TableIframe',
      humanValue: 'Table',
      component: <TableIframe />,
      props: [
        { name: 'tableTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Table Title' },
        {
          name: 'tableTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Table Title Color'
        },
        {
          name: 'tableTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Table Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'tableTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Table Title Text Size (i.e. 15px, 30%...)'
        },
        {
          name: 'tableSource',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Table Source URL'
        },
        {
          name: 'tableExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Table External URL'
        }
      ]
    },
    TEXT: {
      name: 'TEXT',
      value: 'Text',
      humanValue: 'Text',
      component: <Text />,
      props: [
        {
          name: 'titleBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'titleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Color'
        },
        {
          name: 'titleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Title Size (20%, 40px..)'
        },
        {
          name: 'titleContent',
          type: ATLAS_PROP_TYPES.TEXTAREA,
          humanValue: 'Title content'
        },
        {
          name: 'textBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Text Background Color'
        },
        {
          name: 'textColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Text Color'
        },
        {
          name: 'textSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Text Size (20%, 40px..)'
        },
        {
          name: 'textContent',
          type: ATLAS_PROP_TYPES.TEXTAREA,
          humanValue: 'Text content'
        },
        {
          name: 'textExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Text External URL'
        }
      ]
    },
    TEXTNAVBAR: {
      name: 'TEXTNAVBAR',
      value: 'TextNavbar',
      humanValue: 'Text Navbar',
      component: <TextNavbar />,
      props: [
        {
          name: 'navbarBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'navbarBorderColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Border Color'
        },
        { name: 'navbarColor', type: ATLAS_PROP_TYPES.COLOR, humanValue: 'Text Color' },
        {
          name: 'navbarHeight',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Height (i.e. 0px, 1rem...)'
        },
        {
          name: 'navbarPad',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Pad (i.e. 0px, 1rem...)'
        },
        { name: 'navbarText', type: ATLAS_PROP_TYPES.TEXTAREA, humanValue: 'Text Content' },
        {
          name: 'navbarTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Text Size (i.e. 15px, 20%...)'
        }
      ]
    },
    VIDEOPLAYER: {
      name: 'VIDEOPLAYER',
      value: 'VideoPlayer',
      humanValue: 'Video',
      component: <VideoPlayer />,
      props: [
        { name: 'videoTitle', type: ATLAS_PROP_TYPES.STRING, humanValue: 'Video Title' },
        {
          name: 'videoTitleColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Video Title Color'
        },
        {
          name: 'videoTitleSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Video Title Size (i.e. 15px, 30%...)'
        },
        {
          name: 'videoTitleTextSize',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Video Title Text Size (i.e. 15px, 30%...)'
        },
        { name: 'videoSource', type: 'string', humanValue: 'Video Source URL' },
        {
          name: 'videoExternalLink',
          type: ATLAS_PROP_TYPES.STRING,
          humanValue: 'Video External URL'
        }
      ]
    },
    AIATLAS: {
      name: 'AIATLAS',
      value: 'AIAtlas',
      humanValue: 'Ai Atlas',
      component: <AIAtlas />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        }
      ]
    },
    CREATEDATASET: {
      name: 'CREATEDATASET',
      value: 'CreateDataset',
      humanValue: 'Create Dataset',
      component: <CreateDataset />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        }
      ]
    },
    ANNOTATIONSATLAS: {
      name: 'ANNOTATIONSATLAS',
      value: 'AnnotationsAtlas',
      humanValue: 'Annotations Altas',
      component: <AnnotationsAtlas />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'video',
          type: ATLAS_PROP_TYPES.SELECT,
          humanValue: 'Video'
        }
      ]
    },
    CAROUSELTHREE: {
      name: 'CAROUSELTHREE',
      value: 'CarouselThree',
      humanValue: 'Carousel',
      component: <CarouselThree />,
      props: [
        {
          name: 'firstCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstCarouselItemProps',
          humanValue: 'First Item'
        },
        {
          name: 'secondCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondCarouselItemProps',
          humanValue: 'Second Item'
        },
        {
          name: 'thirdCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdCarouselItemProps',
          humanValue: 'Third Item'
        }
      ]
    },
    CAROUSELFOUR: {
      name: 'CAROUSELFOUR',
      value: 'CarouselFour',
      humanValue: 'Carousel',
      component: <CarouselFour />,
      props: [
        {
          name: 'firstCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstCarouselItemProps',
          humanValue: 'First Item'
        },
        {
          name: 'secondCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondCarouselItemProps',
          humanValue: 'Second Item'
        },
        {
          name: 'thirdCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdCarouselItemProps',
          humanValue: 'Third Item'
        },
        {
          name: 'fourthCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fourthCarouselItemProps',
          humanValue: 'Fourth Item'
        }
      ]
    },
    CAROUSELFIVE: {
      name: 'CAROUSELFIVE',
      value: 'CarouselFive',
      humanValue: 'Carousel',
      component: <CarouselFive />,
      props: [
        {
          name: 'firstCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstCarouselItemProps',
          humanValue: 'First Item'
        },
        {
          name: 'secondCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondCarouselItemProps',
          humanValue: 'Second Item'
        },
        {
          name: 'thirdCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdCarouselItemProps',
          humanValue: 'Third Item'
        },
        {
          name: 'fourthCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fourthCarouselItemProps',
          humanValue: 'Fourth Item'
        },
        {
          name: 'fifthCarouselItem',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fifthCarouselItemProps',
          humanValue: 'Fifth Item'
        }
      ]
    },
    FOCUSEDTRAINATLAS: {
      name: 'FOCUSEDTRAINATLAS',
      value: 'FocusedTrainAtlas',
      humanValue: 'Focused Training Atlas',
      component: <FocusedTrainAtlas />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        }
      ]
    },
    GRIDDICEHORIZONTAL: {
      name: 'GRIDDICEHORIZONTAL',
      value: 'GridDiceHorizontal',
      humanValue: 'Grid',
      component: <GridDiceHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'middleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleGridChildProps',
          humanValue: 'Middle Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDDICEVERTICAL: {
      name: 'GRIDDICEVERTICAL',
      value: 'GridDiceVertical',
      humanValue: 'Grid',
      component: <GridDiceVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'middleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleGridChildProps',
          humanValue: 'Middle Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDFOURQUARTERS: {
      name: 'GRIDFOURQUARTERS',
      value: 'GridFourQuarters',
      humanValue: 'Grid',
      component: <GridFourQuarters />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDFOURQUARTERSHORIZONTAL: {
      name: 'GRIDFOURQUARTERSHORIZONTAL',
      value: 'GridFourQuartersHorizontal',
      humanValue: 'Grid',
      component: <GridFourQuartersHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topGridChildProps',
          humanValue: 'Top Child'
        },
        {
          name: 'middleTopGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleTopGridChildProps',
          humanValue: 'Middle-Top Child'
        },
        {
          name: 'middleBottomGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleBottomGridChildProps',
          humanValue: 'Middle-Bottom Child'
        },
        {
          name: 'bottomGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomGridChildProps',
          humanValue: 'Bottom Child'
        }
      ]
    },
    GRIDFOURQUARTERSVERTICAL: {
      name: 'GRIDFOURQUARTERSVERTICAL',
      value: 'GridFourQuartersVertical',
      humanValue: 'Grid',
      component: <GridFourQuartersVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'leftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'leftGridChildProps',
          humanValue: 'Left Child'
        },
        {
          name: 'middleLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleLeftGridChildProps',
          humanValue: 'Middle-Left Child'
        },
        {
          name: 'middleRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleRightGridChildProps',
          humanValue: 'Middle-Right Child'
        },
        {
          name: 'rightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'rightGridChildProps',
          humanValue: 'Right Child'
        }
      ]
    },
    GRIDONE: {
      name: 'GRIDONE',
      value: 'GridOne',
      humanValue: 'Grid',
      component: <GridOne />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'gridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'gridChildProps',
          humanValue: 'Child'
        }
      ]
    },
    GRIDONEHALFTWOQUARTERS: {
      name: 'GRIDONEHALFTWOQUARTERS',
      value: 'GridOneHalfTwoQuarters',
      humanValue: 'Grid',
      component: <GridOneHalfTwoQuarters />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'leftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'leftGridChildProps',
          humanValue: 'Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDONEHALFTWOQUARTERSHORIZONTAL: {
      name: 'GRIDONEHALFTWOQUARTERSHORIZONTAL',
      value: 'GridOneHalfTwoQuartersHorizontal',
      humanValue: 'Grid',
      component: <GridOneHalfTwoQuartersHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topGridChildProps',
          humanValue: 'Top Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDSIXSIXTHSHORIZONTAL: {
      name: 'GRIDSIXSIXTHSHORIZONTAL',
      value: 'GridSixSixthsHorizontal',
      humanValue: 'Grid',
      component: <GridSixSixthsHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'middleLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleLeftGridChildProps',
          humanValue: 'Middle-Left Child'
        },
        {
          name: 'middleRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleRightGridChildProps',
          humanValue: 'Middle-Right Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDSIXSIXTHSVERTICAL: {
      name: 'GRIDSIXSIXTHSVERTICAL',
      value: 'GridSixSixthsVertical',
      humanValue: 'Grid',
      component: <GridSixSixthsVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topMiddleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topMiddleGridChildProps',
          humanValue: 'Top-Middle Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomMiddleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomMiddleGridChildProps',
          humanValue: 'Bottom-Middle Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDTHREESIXTHSTWOQUARTERSHORIZONTAL: {
      name: 'GRIDTHREESIXTHSTWOQUARTERSHORIZONTAL',
      value: 'GridThreeSixthsTwoQuartersHorizontal',
      humanValue: 'Grid',
      component: <GridThreeSixthsTwoQuartersHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topMiddleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topMiddleGridChildProps',
          humanValue: 'Top-Middle Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDTHREESIXTHSTWOQUARTERSVERTICAL: {
      name: 'GRIDTHREESIXTHSTWOQUARTERSVERTICAL',
      value: 'GridThreeSixthsTwoQuartersVertical',
      humanValue: 'Grid',
      component: <GridThreeSixthsTwoQuartersVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'middleLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleLeftGridChildProps',
          humanValue: 'Middle-Left Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDTHREETHIRDS: {
      name: 'GRIDTHREETHIRDS',
      value: 'GridThreeThirds',
      humanValue: 'Grid',
      component: <GridThreeThirds />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'rightGridChildProps',
          humanValue: 'Right Child'
        },
        {
          name: 'middleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleGridChildProps',
          humanValue: 'Middle Child'
        },
        {
          name: 'bottomGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'leftGridChildProps',
          humanValue: 'Left Child'
        }
      ]
    },
    GRIDTHREETHIRDSVERTICAL: {
      name: 'GRIDTHREETHIRDSVERTICAL',
      value: 'GridThreeThirdsVertical',
      humanValue: 'Grid',
      component: <GridThreeThirdsVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'leftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'leftGridChildProps',
          humanValue: 'Left Child'
        },
        {
          name: 'middleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleGridChildProps',
          humanValue: 'Middle Child'
        },
        {
          name: 'rightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'rightGridChildProps',
          humanValue: 'Right Child'
        }
      ]
    },
    GRIDTWOHALVES: {
      name: 'GRIDTWOHALVES',
      value: 'GridTwoHalves',
      humanValue: 'Grid',
      component: <GridTwoHalves />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'leftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'leftGridChildProps',
          humanValue: 'Left Child'
        },
        {
          name: 'rightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'rightGridChildProps',
          humanValue: 'Right Child'
        }
      ]
    },
    GRIDTWOHALVESHORIZONTAL: {
      name: 'GRIDTWOHALVESHORIZONTAL',
      value: 'GridTwoHalvesHorizontal',
      humanValue: 'Grid',
      component: <GridTwoHalvesHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topGridChildProps',
          humanValue: 'Top Child'
        },
        {
          name: 'bottomGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomGridChildProps',
          humanValue: 'Bottom Child'
        }
      ]
    },
    GRIDTWOQUARTERSONEHALF: {
      name: 'GRIDTWOQUARTERSONEHALF',
      value: 'GridTwoQuartersOneHalf',
      humanValue: 'Grid',
      component: <GridTwoQuartersOneHalf />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'rightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'rightGridChildProps',
          humanValue: 'Right Child'
        }
      ]
    },
    GRIDTWOQUARTERSONEHALFHORIZONTAL: {
      name: 'GRIDTWOQUARTERSONEHALFHORIZONTAL',
      value: 'GridTwoQuartersOneHalfHorizontal',
      humanValue: 'Grid',
      component: <GridTwoQuartersOneHalfHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomGridChildProps',
          humanValue: 'Bottom Child'
        }
      ]
    },
    GRIDTWOQUARTERSTHREESIXTHSHORIZONTAL: {
      name: 'GRIDTWOQUARTERSTHREESIXTHSHORIZONTAL',
      value: 'GridTwoQuartersThreeSixthsHorizontal',
      humanValue: 'Grid',
      component: <GridTwoQuartersThreeSixthsHorizontal />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'bottomMiddleGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomMiddleGridChildProps',
          humanValue: 'Bottom-Middle Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    GRIDTWOQUARTERSTHREESIXTHSVERTICAL: {
      name: 'GRIDTWOQUARTERSTHREESIXTHSVERTICAL',
      value: 'GridTwoQuartersThreeSixthsVertical',
      humanValue: 'Grid',
      component: <GridTwoQuartersThreeSixthsVertical />,
      props: [
        {
          name: 'gridBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Background Color'
        },
        {
          name: 'topLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topLeftGridChildProps',
          humanValue: 'Top-Left Child'
        },
        {
          name: 'bottomLeftGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomLeftGridChildProps',
          humanValue: 'Bottom-Left Child'
        },
        {
          name: 'topRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'topRightGridChildProps',
          humanValue: 'Top-Right Child'
        },
        {
          name: 'middleRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'middleRightGridChildProps',
          humanValue: 'Middle-Right Child'
        },
        {
          name: 'bottomRightGridChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'bottomRightGridChildProps',
          humanValue: 'Bottom-Right Child'
        }
      ]
    },
    SECTIONSFIVE: {
      name: 'SECTIONSFIVE',
      value: 'SectionsFive',
      humanValue: 'Style and Content',
      component: <SectionsFive />,
      props: [
        {
          name: 'navBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'navColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Text Color'
        },
        {
          name: 'navBorder',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Box Border Color'
        },
        {
          name: 'firstSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Title Text'
        },
        {
          name: 'firstSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionHeightProps',
          humanValue: 'First Item Height  (20%, 40px)'
        },
        {
          name: 'sectionFirstChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Item Content'
        },
        {
          name: 'secondSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Title Text'
        },
        {
          name: 'secondSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionHeightProps',
          humanValue: 'Second Item Height  (20%, 40px)'
        },
        {
          name: 'sectionSecondChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Item Content'
        },
        {
          name: 'thirdSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Title Text'
        },
        {
          name: 'thirdSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionHeightProps',
          humanValue: 'Third Item Height  (20%, 40px)'
        },
        {
          name: 'sectionThirdChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Item Content'
        },
        {
          name: 'fourthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Title Text'
        },
        {
          name: 'fourthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionHeightProps',
          humanValue: 'Fourth Item Height (20%, 40px)'
        },
        {
          name: 'sectionFourthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Item Content'
        },
        {
          name: 'fifthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fifthSectionChildProps',
          humanValue: 'Fifth Title Text'
        },
        {
          name: 'fifthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fifthSectionHeightProps',
          humanValue: 'Fifth Item Height (20%, 40px)'
        },
        {
          name: 'sectionFifthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fifthSectionChildProps',
          humanValue: 'Fifth Item Content'
        }
      ]
    },
    SECTIONSFOUR: {
      name: 'SECTIONSFOUR',
      value: 'SectionsFour',
      humanValue: 'Style and Content',
      component: <SectionsFour />,
      props: [
        {
          name: 'navBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'navColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Text Color'
        },
        {
          name: 'navBorder',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Box Border Color'
        },
        {
          name: 'firstSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Title Text'
        },
        {
          name: 'firstSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionHeightProps',
          humanValue: 'First Item Height  (20%, 40px)'
        },
        {
          name: 'sectionFirstChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Item Content'
        },
        {
          name: 'secondSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Title Text'
        },
        {
          name: 'secondSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionHeightProps',
          humanValue: 'Second Item Height  (20%, 40px)'
        },
        {
          name: 'sectionSecondChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Item Content'
        },
        {
          name: 'thirdSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Title Text'
        },
        {
          name: 'thirdSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionHeightProps',
          humanValue: 'Third Item Height  (20%, 40px)'
        },
        {
          name: 'sectionThirdChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Item Content'
        },
        {
          name: 'fourthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Title Text'
        },
        {
          name: 'fourthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionHeightProps',
          humanValue: 'Fourth Item Height (20%, 40px)'
        },
        {
          name: 'sectionFourthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Item Content'
        }
      ]
    },
    SECTIONSSIX: {
      name: 'SECTIONSSIX',
      value: 'SectionsSix',
      humanValue: 'Style and Content',
      component: <SectionsSix />,
      props: [
        {
          name: 'navBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'navColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Text Color'
        },
        {
          name: 'navBorder',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Box Border Color'
        },
        {
          name: 'firstSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Title Text'
        },
        {
          name: 'firstSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionHeightProps',
          humanValue: 'First Item Height  (20%, 40px)'
        },
        {
          name: 'sectionFirstChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Item Content'
        },
        {
          name: 'secondSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Title Text'
        },
        {
          name: 'secondSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionHeightProps',
          humanValue: 'Second Item Height  (20%, 40px)'
        },
        {
          name: 'sectionSecondChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Item Content'
        },
        {
          name: 'thirdSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Title Text'
        },
        {
          name: 'thirdSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionHeightProps',
          humanValue: 'Third Item Height  (20%, 40px)'
        },
        {
          name: 'sectionThirdChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Item Content'
        },
        {
          name: 'fourthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Title Text'
        },
        {
          name: 'fourthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fourthSectionHeightProps',
          humanValue: 'Fourth Item Height (20%, 40px)'
        },
        {
          name: 'sectionFourthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fourthSectionChildProps',
          humanValue: 'Fourth Item Content'
        },
        {
          name: 'fifthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fifthSectionChildProps',
          humanValue: 'Fifth Title Text'
        },
        {
          name: 'fifthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'fifthSectionHeightProps',
          humanValue: 'Fifth Item Height (20%, 40px)'
        },
        {
          name: 'sectionFifthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'fifthSectionChildProps',
          humanValue: 'Fifth Item Content'
        },
        {
          name: 'sixthSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'sixthSectionChildProps',
          humanValue: 'Sixth Title Text'
        },
        {
          name: 'sixthSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'sixthSectionHeightProps',
          humanValue: 'Sixth Item Height (20%, 40px)'
        },
        {
          name: 'sectionSixthChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'sixhSectionChildProps',
          humanValue: 'Sixth Item Content'
        }
      ]
    },
    SECTIONSTHREE: {
      name: 'SECTIONSTHREE',
      value: 'SectionsThree',
      humanValue: 'Style and Content',
      component: <SectionsThree />,
      props: [
        {
          name: 'navBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'navColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Text Color'
        },
        {
          name: 'navBorder',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Box Border Color'
        },
        {
          name: 'firstSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Title Text'
        },
        {
          name: 'firstSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionHeightProps',
          humanValue: 'First Item Height  (20%, 40px)'
        },
        {
          name: 'sectionFirstChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Item Content'
        },
        {
          name: 'secondSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Title Text'
        },
        {
          name: 'secondSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionHeightProps',
          humanValue: 'Second Item Height  (20%, 40px)'
        },
        {
          name: 'sectionSecondChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Item Content'
        },
        {
          name: 'thirdSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Title Text'
        },
        {
          name: 'thirdSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'thirdSectionHeightProps',
          humanValue: 'Third Item Height  (20%, 40px)'
        },
        {
          name: 'sectionThirdChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'thirdSectionChildProps',
          humanValue: 'Third Item Content'
        }
      ]
    },
    SECTIONSTWO: {
      name: 'SECTIONSTWO',
      value: 'SectionsTwo',
      humanValue: 'Style and Content',
      component: <SectionsTwo />,
      props: [
        {
          name: 'navBackgroundColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Background Color'
        },
        {
          name: 'navColor',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Text Color'
        },
        {
          name: 'navBorder',
          type: ATLAS_PROP_TYPES.COLOR,
          humanValue: 'Title Box Border Color'
        },
        {
          name: 'firstSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Title Text'
        },
        {
          name: 'firstSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'firstSectionHeightProps',
          humanValue: 'First  Item Height  (20%, 40px)'
        },
        {
          name: 'sectionFirstChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'firstSectionChildProps',
          humanValue: 'First Item Content'
        },
        {
          name: 'secondSection',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Title Text'
        },
        {
          name: 'secondSectionHeight',
          type: ATLAS_PROP_TYPES.STRING,
          propObjectName: 'secondSectionHeightProps',
          humanValue: 'Second Item Height  (20%, 40px)'
        },
        {
          name: 'sectionSecondChild',
          type: ATLAS_PROP_TYPES.NODE,
          propObjectName: 'secondSectionChildProps',
          humanValue: 'Second Item Content'
        }
      ]
    }
  }
};

export const ATLAS_CHILDS = pick(ATLAS_ELEMENTS.properties, [
  'ATLASIFRAME',
  'GRAPHICIFRAME',
  'IMAGEELEMENT',
  'MAPIFRAME',
  'OGR2OGRCONFIGURATION',
  'TABLEIFRAME',
  'TEXT',
  'VIDEOPLAYER'
]);

export const ATLAS_TEMPLATES = {
  TEMPLATESCORECARDONECOMPONENT: 'templateScorecardOneComponent',
  TEMPLATESCORECARDTWOCOMPONENTS: 'templateScorecardTwoComponents',
  TEMPLATESCORECARDTHREECOMPONENTS: 'templateScorecardThreeComponents',
  TEMPLATESCORECARDFOURCOMPONENTS: 'templateScorecardFourComponents',
  TEMPLATESCORECARDSIXCOMPONENTS: 'templateScorecardSixComponents',
  TEMPLATESCORECARDSECTIONS: 'templateScorecardSections',
  TEMPLATESCORECARDAIATLAS: 'templateScorecardAIAtlas',
  TEMPLATESCORECARDCREATEDATASET: 'templateScorecardCreateDataset',
  TEMPLATESCORECARDTASKERATLAS: 'templateScorecardTaskerAtlas',
  TEMPLATESCORECARDANNOTATIONSATLAS: 'templateScorecardAnnotationsAtlas',
  TEMPLATESCORECARDFOCUSEDTRAINATLAS: 'templateScorecardFocusedTrainAtlas',
  properties: {
    TEMPLATESCORECARDONECOMPONENT: {
      type: 'Dashboard',
      title: 'One component',
      name: 'TEMPLATESCORECARDONECOMPONENT',
      value: 'templateScorecardOneComponent',
      image: '/atlas-templates/OneComponent/image0.png',
      structures: [[ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDONE]]
    },
    TEMPLATESCORECARDTWOCOMPONENTS: {
      type: 'Dashboard',
      title: 'Two components',
      name: 'TEMPLATESCORECARDTWOCOMPONENTS',
      value: 'templateScorecardTwoComponents',
      image: '/atlas-templates/TwoComponents/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOHALVES],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOHALVESHORIZONTAL]
      ]
    },
    TEMPLATESCORECARDTHREECOMPONENTS: {
      type: 'Dashboard',
      title: 'Three components',
      name: 'TEMPLATESCORECARDTHREECOMPONENTS',
      value: 'templateScorecardThreeComponents',
      image: '/atlas-templates/ThreeComponents/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDONEHALFTWOQUARTERS],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOQUARTERSONEHALF],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDONEHALFTWOQUARTERSHORIZONTAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOQUARTERSONEHALFHORIZONTAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTHREETHIRDSVERTICAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTHREETHIRDS]
      ]
    },
    TEMPLATESCORECARDFOURCOMPONENTS: {
      type: 'Dashboard',
      title: 'Four components',
      name: 'TEMPLATESCORECARDFOURCOMPONENTS',
      value: 'templateScorecardFourComponents',
      image: '/atlas-templates/FourComponents/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDFOURQUARTERS],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDFOURQUARTERSVERTICAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDFOURQUARTERSHORIZONTAL]
      ]
    },
    TEMPLATESCORECARDFIVECOMPONENTS: {
      type: 'Dashboard',
      title: 'Five components',
      name: 'TEMPLATESCORECARDFIVECOMPONENTS',
      value: 'templateScorecardFiveComponents',
      image: '/atlas-templates/FiveComponents/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOQUARTERSTHREESIXTHSHORIZONTAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTHREESIXTHSTWOQUARTERSHORIZONTAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTHREESIXTHSTWOQUARTERSVERTICAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDTWOQUARTERSTHREESIXTHSVERTICAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDDICEHORIZONTAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDDICEVERTICAL]
      ]
    },
    TEMPLATESCORECARDSIXCOMPONENTS: {
      type: 'Dashboard',
      title: 'Six components',
      name: 'TEMPLATESCORECARDSIXCOMPONENTS',
      value: 'templateScorecardSixComponents',
      image: '/atlas-templates/SixComponents/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDSIXSIXTHSVERTICAL],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.GRIDSIXSIXTHSHORIZONTAL]
      ]
    },
    TEMPLATESCORECARDSECTIONS: {
      type: 'Dashboard',
      title: 'Core',
      name: 'TEMPLATESCORECARDSECTIONS',
      value: 'templateScorecardSections',
      image: '/atlas-templates/Sections/image1.png',
      structures: [
        [ATLAS_ELEMENTS.SECTIONSTWO],
        [ATLAS_ELEMENTS.SECTIONSTHREE],
        [ATLAS_ELEMENTS.SECTIONSFOUR],
        [ATLAS_ELEMENTS.SECTIONSFIVE],
        [ATLAS_ELEMENTS.SECTIONSSIX]
      ]
    },
    TEMPLATESCORECARDCAROUSEL: {
      type: 'Dashboard',
      title: 'Carousel',
      name: 'TEMPLATESCORECARDCAROUSEL',
      value: 'templateScorecardCarousel',
      image: '/atlas-templates/Carousel/image0.png',
      structures: [
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.CAROUSELTHREE],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.CAROUSELFOUR],
        [ATLAS_ELEMENTS.TEXTNAVBAR, ATLAS_ELEMENTS.CAROUSELFIVE]
      ]
    },
    TEMPLATESCORECARDAIATLAS: {
      type: 'AI Atlas',
      title: 'IA',
      name: 'TEMPLATESCORECARDAIATLAS',
      value: 'templateScorecardAIAtlas',
      image: '/atlas-templates/AIAtlas/image0.png',
      structures: [[ATLAS_ELEMENTS.AIATLAS]]
    },

    TEMPLATESCORECARDCREATEDATASET: {
      type: 'AI Atlas',
      title: 'Create data set',
      name: 'TEMPLATESCORECARDCREATEDATASET',
      value: 'templateScorecardCreateDataset',
      image: '/atlas-templates/DataSet/image0.jpg',
      structures: [[ATLAS_ELEMENTS.CREATEDATASET]]
    },

    TEMPLATESCORECARDFOCUSEDTRAINATLAS: {
      type: 'Others',
      title: 'Train IA',
      name: 'TEMPLATESCORECARDFOCUSEDTRAINATLAS',
      value: 'templateScorecardFocusedTrainAtlas',
      image: '/atlas-templates/FocusedTrainAtlas/image0.png',
      structures: [[ATLAS_ELEMENTS.FOCUSEDTRAINATLAS]]
    },
    TEMPLATESCORECARDANNOTATIONSATLAS: {
      type: 'Others',
      title: 'Annotations',
      name: 'TEMPLATESCORECARDANNOTATIONSATLAS',
      value: 'templateScorecardAnnotationsAtlas',
      image: '/atlas-templates/AnnotationsAtlas/image0.png',
      structures: [[ATLAS_ELEMENTS.ANNOTATIONSATLAS]]
    }
  }
};

export const ANNOTATIONS_TYPES = pick(ATLAS_TEMPLATES, ['TEMPLATESCORECARDANNOTATIONSATLAS']);
